import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=1f1fb7f0&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=1f1fb7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1fb7f0",
  null
  
)

export default component.exports